var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "page-area privacy-policy-page-area" }, [
      _c("div", { staticClass: "privacy-policy-area" }, [
        _c("div", { staticClass: "container" }, [
          _vm.getLocale() == "zh"
            ? _c("div", { staticClass: "row justify-content-center" }, [
                _vm._m(0),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getLocale() == "en"
            ? _c("div", { staticClass: "row justify-content-center" }, [
                _vm._m(1),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-9" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c("div", { staticClass: "privacy-policy-header text-center" }, [
            _c("h1", [
              _vm._v(
                "\n                        私隱條例\n                      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "privacy-policy-content" }, [
            _c("h2", [_vm._v("個人資料收集聲明及使用和披露個人數據同意書")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        本聲明適用於Money Plaza (Hong Kong) Limited\n                        （下稱「本公司」 或「我們」）。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        在本聲明中，「資料當事人」或「閣下」一詞將涵蓋以下個別人士類別，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        包括：網頁訪客，以及透過本網站從我們的第三方貸方網絡（可能是持牌銀行丶金融機構或持牌放債人）\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        （稱為「貸款提供者」）申請貸款相關產品或服務的貸款申請人。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        本聲明的內容適用於所有資料當事人，並構成其與本公司不時訂立或可能訂立的任何協議及/或安排的一部分。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        若本聲明與有關協議及/或安排存在任何差異或分歧，就有關保護資料當事人的個人資料而言槪以本聲明爲準。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("收集目的")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        1.\n                        為便我們提供服務，資料當事人必須提供個人資料以從貸款提供者建立貸款服務丶處理新或延續貸款申請及獲得相關服務。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        2.\n                        若資料當事人未能提供該個人資料，本公司可能無法向貸款提供者提供相關資料，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        以便為閣下提供貸款服務丶處理貸款申請或其他相關服務。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        3.\n                        為了從貸款提供者建立貸款服務丶處理新或延續貸款申請及獲得相關服務，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        本公司和/或貸款提供者也可從信用諮詢機構獲取資料當事人的個人數據（其聯繫方式可由貸款提供者根據要求提供），\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        或透過不同途徑如公共登記冊丶公共搜索引擎丶公共名冊或資料當事人已授權設定為公開分享的任何社交媒體等公共領域查閱及取得資料當事人的個人資料。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        另外，亦會透過資料當事人的網頁瀏覽器取得資料當事人的裝置資料。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("個人資料的收集")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        4.\n                        個人資料指任何與個人有關的資料，而從該資料可直接或間接地確定有關個人的身分。我們可能收集（包括但不限於）以下資料，而其可能不時成為個人資料︰\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v("‧姓名；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧年齡；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧性別；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧電話號碼；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧電郵地址；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧香港身份證號碼或護照號碼；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧國籍或居留身分；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧出生日期；")]),
              _vm._v(" "),
              _c("li", [
                _vm._v("‧個人財務狀況，意願或目標 （包括貸款需要）；"),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧收入或財產資料；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧教育程度；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧就業資料；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧居住資料；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧銀行戶口或儲值支付工具戶口之詳情；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧Facebook ID及在Facebook顯示的名稱；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧LinkedIn ID及其相關資訊；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧對任何產品或服務的偏好；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧閣下與本公司的對話內容；")]),
              _vm._v(" "),
              _c("li", [
                _vm._v("‧有關閣下瀏覽及使用我們的網站及Chatbot的資料；"),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧位置資料；及")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                          ‧信用數據（包括已向您提供信貸和/或貸款的銀行或金融機構的名稱，以及信貸限額和貸款金額丶信貸使用率丶還款記錄丶查詢記錄和信用評分）。\n                        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        5.\n                        另外，當閣下使用我們的網站或服務時，我們可能會自動收集某些資料，而該資料在與閣下的其他資料相結合時可能會成為個人資料。上述資料包括但不限於：\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                          ‧閣下正在使用的裝置或器材的屬性，如操作系統、硬件版本、裝置設定、軟件及裝置識別碼；\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                          ‧裝置的位置，包括通過全球定位系統、藍芽、WiFi訊號或其他方法取得的特定地理位置；\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                          ‧流動網絡資料，如閣下的流動網絡供應商、互聯網服務供應商或其他服務供應商的名稱、網頁瀏覽器種類以及IP位址；\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧將閣下導入我們的網站的網頁；")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧閣下在我們的網站所瀏覽的頁面；")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                          ‧閣下查閱的產品和服務詳情以及閣下使用我們網站上的資料、工具和其他內容；及\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧閣下於我們網站上點擊的連結。")]),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("個人資料的使用")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("6. 資料當事人的個人資料可被本公司用作以下用途︰"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        a.將閣下與貸款提供者進行配對並提供轉介服務;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        b.在必要時回復閣下的疑問和要求，並與閣下聯絡以便提供客戶服務;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        c.讓閣下使用我們的網站時都有良好的用戶體驗;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        d.解決投訴及處理要求及查詢;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        e.舉辦宣傳活動;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        f.讓貸款提供者能夠考慮和處理貸款申請或新或延續貸款申請的產品及服務所涉及之日常運作\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        （包括貸款提供者向資料當事人提供的貸款及相關產品和服務）;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        g.讓貸款提供者能夠在適當的情況下進行信貸調查（包括客戶申請貸款時以及於正常情況下每年一次或多於一次的定期或特別信貸覆核）；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        h.讓貸款提供者能夠協助其他金融機構作信用檢查及追討債務；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        i.讓貸款提供者能夠設計供客戶使用的貸款/信用服務或有關產品和服務；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        j.進行市場調查或發展會員計劃；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        k.在資料當事人的同意下，直接促銷服務﹑市場產品和服務及在以下第\n                        8段及第 9 段提及的其他事項；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        l.確使本公司內的任何機構能夠履行義務﹑規定或安排，不論是強制性或自願性，以遵守或遵守相關：\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        aa.目前或將來存在的對本公司及本集團內的任何機構具法律約束力或適用的任何法律﹑規例﹑判詞﹑法庭命令﹑義務守則或制裁制度；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        bb.不論於香港特別行政區境內或境外及不論目前或將來存在的任何法律﹑監管﹑政府﹑稅務﹑執法或其他機關，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        或相關證券交易所﹑金融服務供應商的自律監管或行業組織或協會作出或發出的任何指引或指導或業務守則或要求；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        cc.本公司及本集團內的任何機構因其位於或跟相關本地或外地的法律﹑監管﹑司法﹑行政﹑公共或執法團體﹑\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        政府﹑稅務﹑收入﹑金融﹑法庭﹑其他機關﹑或相關證券交易所﹑金融服務供應商的自律監管或行業組織或協會或任何他們的中介人承擔或被彼等施加目前或將來的合約或其他承諾；及\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        dd.上述中描述的當局之間的任何協議或條約。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        m.遵守本公司內的任何機構為符合制裁或預防或偵測清洗黑錢﹑恐怖分子融資活動或其他非法活動的任何方案就於本公司或\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        內的任何機構內共用資料及資訊及／或資料及資訊的任何其他使用而指定的任何義務﹑要求﹑政策﹑程序﹑措施或安排；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        n.供本公司全部或任何部份業務及／或資產的實際或潛在承讓人，或本公司對資料當事人的貸款／信貸設施的權利的參與人或附屬參與人，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        可以衡量有關轉讓、參與或附屬參與所涉交易，和容許實際承讓人在經營業務或分配權利時使用此等資料；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        o.讓貸款提供者能夠\n                        比較資料當事人及其他人士就信貸審批﹑資料核證及製作或核實資料而提供的資料，不論是否為對該資料當事人採取行動的目的；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        p.讓貸款提供者能夠維持資料當事人的信貸紀錄\n                        （無論資料當事人與本公司的關係是否存在）\n                        作現在或未來參考；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        q.管理﹑提升﹑維持及提供Chatbot及處理或與資料當事人溝通其透過Chatbot提出的任何查詢或要求;\n                        及\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        r.與上述用途有關的任何其他用途。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("個人資料披露")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        7.本公司持有的所有個人資料將予保密，但本公司可能會把該等資料披露或轉移給下列各方以達至第6段中的目的︰\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        a.貸款提供者;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        b.任何代理人﹑承包商﹑次承包商或本公司的關聯人士或本集團內的任何機構（包括其員工﹑人員﹑代理商﹑承包商﹑服務提供商和專業顧問）；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        c.任何向本公司或本集團內的任何機構提供行政﹑專業﹑諮詢﹑電訊﹑資料服務﹑電腦﹑付款﹑數據處理﹑收債或\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        其他與本公司業務運作有關的其他服務的第三方服務供應商；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        d.任何對本公司有保密責任及已承諾保密該等資料的人；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        e.付款銀行向出票人提供繳款支票的複印本（可能包含有關收款人的資訊）;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        f.代表自己和/或代理人的貸款提供者﹑信貸調查機構，以及在欠賬時則為收數公司；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        g.上述第6段所述的任何當局﹑團體﹑協會或人士；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        aa.本公司的任何實際或建議承讓人或本公司或參與者或次參與者就資料當事人對貸款／信貸設施的權利；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        bb.與本公司一起為資料當事人提供產品或服務的業務合作夥伴或品牌合作夥伴；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        cc.根據資料當事人就第6段提及的目的之同意︰\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        dd.第三者金融服務機構﹑保險人﹑信用卡公司﹑證券及期貨及投資服務供應商﹑第三方會員計劃提供者或我們的品牌合作夥伴；及\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        ee.第三者服務供應商（包括但不限於代客寄件中心﹑電訊公司﹑電話行銷及直銷代理人﹑電話中心﹑數據處理公司及資訊科技公司）。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("直接促銷")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        8.本公司擬把資料當事人的資料用於產品或服務的直接促銷，唯該用途須獲得資料當事人的同意（包括對該用途不表示反對的標明）。就此，請知悉︰\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        a.我們可能把不時持有的客戶姓名﹑聯絡資料﹑産品及其他服務組合資料﹑交易模式及行爲﹑財務背景及人口統計數據用於本公司的直接促銷；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        b.可用作促銷下列類別的服務﹑産品及項目包括信貸/貸款﹑其他金融服務及產品﹑會員計劃﹑其相關服務及產品，以及我們的品牌合作夥伴所提供的服務及產品；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        c.上述服務﹑産品及項目可能由本公司和本集團內的任何機構或第三者財務機構﹑保險人﹑證券及投資服務供應商所提供；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        d.除由本公司促銷上述服務﹑産品及項目以外，本公司亦擬將以上a.段所述的資料提供予以上c.段所述的全部或任何人士，以供該等人士在促銷該等服務﹑産品及項目時使用，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        e.而\n                        本公司爲此用途須獲得資料當時人的同意（包括對該用途不表示反對的標明）；及\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        f.本公司可能因以上c.段所述將資料提供予其他人士，或按以上d.段所述請求資料當事人的同意或不表示反對，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        而獲得金錢或其他財產的回報。如本公司會因提供資料予其他人士而獲得任何金錢或其他財產的回報，本公司會通知資料當事人。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        g.如閣下不希望本公司將其個人資料按以上所述使用或提供予其他人作直接促銷之用，閣下可通知我們以行使其選擇拒絕促銷之權利。\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("查閱及更正個人資料")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        9.根據條例及個人信貸資料實務守則（「守則」）的條款，閣下有權︰\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        a.查核本公司是否持有閣下的個人資料及查閱該等資料；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        b.要求本公司改正任何有關閣下不準確的個人資料；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        c.查明本公司對於個人資料的政策及做法和獲告知本公司所持有的個人資料種類；\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        d.就消費者信貸而言，閣下可以要求獲告知那些資料會被例行披露予信貸資料服務機構或追討欠款公司，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        及獲本公司提供進一步資料，以便向有關信貸資料服務機構或追討欠款公司提出查閱和改正資料的要求；及\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        e.就消費者信貸而言，在帳戶全數清還欠款後結束帳戶時，指示本公司向信貸資料服務機構要求從其資料庫中刪除與該已結束帳戶有關的任何帳戶資料，\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        惟是項指示須於終止戶口後五年內提出，以及無重大拖欠。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        10.根據條例的條款，本公司有權就處理任何查閱資料的要求收取合理費用。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        11.閣下應將任何有關瀏覽個人資料或更正個人資料的請求，或任何有關我們對個人資料的政策和做法的查詢發送至︰\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        Money Plaza (Hong Kong) Limited\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        荃灣海盛路11號ONE MIDTOWN521室\n                        "
              ),
              _c("br"),
              _vm._v(" "),
              _c("a", { attrs: { href: "mailto:info@moneyplaza.com.hk" } }, [
                _vm._v("info@moneyplaza.com.hk"),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        12. 本聲明不會限制資料當事人在條例下所享有的權利。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        13.\n                        本公司在考慮任何貸款相關的產品或服務申請或不時進行信用評估時，可能已從信貸資料服務機構取得與資料當事人有關的信貸報告。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        若資料當事人擬取得該信貸報告，本公司會將有關信貸資料服務機構的聯絡詳情告知資料當事人。\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        14. 若中文與英文版本出現差異，概以英文版本為準。\n                      "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-9" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c("div", { staticClass: "privacy-policy-header text-center" }, [
            _c("h1", [
              _vm._v(
                "\n                        PRIVACY POLICY\n                      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "privacy-policy-content" }, [
            _c("p", [
              _vm._v(
                "\n                        This Statement applies to Money Plaza Hong Kong Limited (“the Company” or “we”) or its subsidiaries from time to time (“the Group”).\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        In this Statement, the term “data subjects” or “you” shall include visitors to this website and applicants for loan-related products or facilities from our network of third-party lenders and financial services providers  (which may be licensed banks, financial institutions or licensed money lenders) through this website (“Loan Providers”).\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        The content of this Statement shall apply to all data subjects and form part of the terms and conditions of any agreement or arrangement that the data subjects have or may enter into with the Company from time to time. In the event of any inconsistency or discrepancy between this Statement and the relevant agreement or arrangement, this Statement shall prevail insofar as it relates to the protection of the data subject’s personal data.\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Purpose of Collection")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        1. For the purposes of the provision of services by us, it is necessary for data subjects to supply us with personal data for the purposes of the establishment of loan facilities or the processing of new or renewal applications or other services from the Loan Providers, for the purposes of reward applications by successful applicants, who has successfully completed and subscribe for the services they have applied for, where the reward will distribute if and only if applicants’ applications details is matching with our network of third-party lenders and financial services provider.\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        2. Failure to supply such personal data by data subjects may result in the Company being unable to provide relevant information to the Loan Providers for providing you with loan facilities or process applications or other services.\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        3. For the purposes of the establishment of loan facilities or the processing of new or renewal applications or other services by the Loan Providers, personal data of data subjects may also be obtained by the Loan Providers from credit reference agency (whose contact details can be provided by the Loan Providers upon request) or from the public domain through different channels, including public registers, public search engines, public directories or any social media with public view setting authorised by the data subject. In addition, device information may be collected from data subjects’ web browsers.\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Collection of Personal Data")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        4. Personal data means any information relating to an individual from which the identity of the individual can be ascertained, directly or indirectly. We may collect the following data relating to you, which may be personal data from time to time, including but not limited to:\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v("‧name;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧age;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧gender;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧phone number;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧WhatsApp number;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧e-mail address;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧HKID number or passport number;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧nationality or residency status;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧birth date;")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "‧personal finance status, intention or goals (including need for loans);"
                ),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧income or assets information;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧education level;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧employment information;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧residential information;")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "‧bank account or stored value facility account details;"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("‧Facebook ID and first name displayed in Facebook;"),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧LinkedIn ID and related information;")]),
              _vm._v(" "),
              _c("li", [_vm._v("‧TE record (Softmedia);")]),
              _vm._v(" "),
              _c("li", [
                _vm._v("‧preferences related to any products or services;"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("‧communications between you and the Company;"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "‧data regarding your visits to and use of our website and Chatbot; and"
                ),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧location data.")]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        In addition, when you use our website or services, we may automatically collect certain data which may, when combined with other information about you, be personal data, including but not limited to:"
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                          ‧attributes of the equipment or device you are using, such as the operating system, hardware version, device settings, software and device identifiers;\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                          ‧device locations, including specific geographic locations identified through GPS, Bluetooth or WiFi signals or other means;\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                          ‧connection information such as the name of your mobile operator, ISP or other service provider, browser type and IP address;\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("‧the website from which you have reached our website;"),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧our website pages viewed;")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                          ‧details of the products and services on our website that you look at, information, tools and content available on our website that you use; and\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("‧links from our website that you click on.")]),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Use of Personal Data")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "6. The personal data of data subjects may be used by the Company for:"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        1.matching you with the Loan Providers and providing referral services;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        2.responding to your queries and requests and contacting you for customer service, if necessary;;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        3.customising your experience with our website;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        4.resolving complaints and handling requests and enquiries;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        5.organising promotional events;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        6.enabling the Loan Providers to consider and process applications for loan facilities or new or renewal applications and the daily operation of products and services (including loan facilities and related products and services provided by the Loan Providers to data subjects);\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        7.enabling the Loan Providers to conduct credit checks whenever appropriate (including at the time of application for loan and when we review credit which normally takes place one or more times each year);\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        8.enabling the Loan Providers to assist other institutions to conduct credit checks and to collect debts;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        9.enabling the Loan Providers to design and develop loan/credit facilities and related financial products and services for customers’ use;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        10.conducting marketing research or developing membership programs;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        11.subject to obtaining the consent of data subjects, direct marketing services, marketing products, services and other subjects as described in paragraphs 8 and 9 below;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        12.meeting obligations, requirements and arrangements, of the Company or its affiliates within the Group, whether compulsory or voluntary, to comply with or in connection with:\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        l3.complying with any obligations, requirements, policies, procedures, measures or arrangements of the Company or its affiliates within Group for the use of data and information for compliance with sanctions or prevention or detection of money laundering, terrorist financing or other unlawful activities;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        14.enabling an actual or proposed assignee or transferee of all or any part of the Company’s business and/or assets, or participant or sub-participant of the Company’s rights in respect of loans/credit facilities relating to data subjects, to evaluate the transaction intended to be the subject of the assignment, transfer, participation or sub-participation and enabling the actual assignee or transferee to use such data in the operation of the business or rights assigned;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        15.enabling the Loan Providers to compare data of data subjects or other persons for credit checking, data verification or otherwise producing or verifying data, whether or not for the purpose of taking action against such data subjects;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        16.enabling the Loan Providers to maintain a credit history of the data subjects (whether or not there exists any relationship between the data subjects and the Company) for present and future reference;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        17.administering, enhancing, maintaining and providing Chatbot and processing, handling or communicating with data subjects in respect of any enquiry or requests raised by data subjects via Chatbot; and\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        18.any other purposes relating to the purposes listed above.\n                        "
              ),
              _c("br"),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Disclosure of Personal Data")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        7.All personal data held by the Company will be kept confidential, but the Company may disclose or transfer such information to the following parties for the purposes set out in paragraph 6 above:\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        (a) the Loan Providers;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        (b) any agent, contractor, sub-contractor or associates of the Company or its affiliates within the Group (including its employees, officers, agents, contractors, service providers and professional advisers);"
              ),
              _c("br"),
              _vm._v(
                "\n                        (c) any third-party service provider who provides administrative, professional, advisory, telecommunication, information service, computer, payment, data processing, debt collection or other services to the Company or its affiliates within Group in connection with the operation or maintenance of its business;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        (d) any other person who is under a duty of confidentiality to the Company and has undertaken to keep such information confidential;"
              ),
              _c("br"),
              _vm._v(
                "\n                        (e) the drawee bank providing a copy of a paid cheque (which may contain data about the payee) to the drawer;"
              ),
              _c("br"),
              _vm._v(
                "\n                        (f) credit reference agencies and, in the event of default, debt collection agencies;\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        (g) any authority, body, association or persons mentioned in paragraph 6(l) above;\n                        "
              ),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "1.any actual or proposed assignee or transferee or the Company or, participant or sub-participant of the Company’s rights in respect of loans/credit facilities relating to data subjects;"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("2.any entities within the Group;")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3.business partners or co-branding partners of the Company together with whom the Company provides products or services to data subjects;"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4.subject to obtaining the consent of data subjects in connection with the purpose set out in paragraph 6(k) above:"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5.third party financial institutions, insurers, credit card companies, securities, commodities and investment services providers, third-party membership program providers or our co-branding partners; and"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "6.external service providers (including but not limited to mailing houses, telecommunication companies, telemarketing and direct sales agents, call centres, data processing companies and information technology companies).\n"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n                        Personal data collected in Hong Kong by the Company may be transferred in and to a place outside Hong Kong."
              ),
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Direct Marketing")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        8.The Company intends to use a data subject’s data to conduct direct marketing of products or services and requires the data subject’s consent (which includes an indication of no objection) for that purpose. In this connection, please note that:\n                        "
              ),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "1.the name, contact details, products and other service portfolio information, transaction pattern and behaviour, financial background and demographic data of data subject held by the Company from time to time may be used by the Company in direct marketing;"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2.the classes of services, products and subjects which may be marketed includes credit/loan facilities and other financial services and products, membership programs and related products and services, products and services offered by our co-branding partners;"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3.the above services, products and subjects may be provided by the Company or its affiliates within the Group, third party financial institutions, insurers, securities and investment services providers, third-party membership program providers or our co-branding partners;"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4.in addition to marketing the above services, products and subjects itself, the Company also intends to provide the data described in sub-paragraph (a) above to all or any of the persons described in sub-paragraph (c) above for use by them in marketing those services, products and subjects, and the Company requires the data subject’s consent (which includes an indication of no objection) for that purpose; and"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5.the Company may receive money or other property in return for providing the data to the other persons in sub-paragraph (c) above and, when requesting data subject’s consent or no objection as described in sub-paragraph (d) above, the Company will inform the data subject if we will receive any money or other property in return for providing the data to the other persons."
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        9.If you do not wish the Company to use or provide to the other persons your data for use in direct marketing as described above, you may exercise your opt-out right by notifying us:\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        Money Plaza (Hong Kong) Limited\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        Room 21, One Midtown,\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        11 Hoi Shing Road, Tsuen Wan\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        Hong Kong\n                        "
              ),
              _c("br"),
              _vm._v(" "),
              _c("a", { attrs: { href: "mailto:info@moneyplaza.com.hk" } }, [
                _vm._v("info@moneyplaza.com.hk"),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        10. Under and in accordance with the terms of the Ordinance and the Code of Practice on Consumer Credit Data (the “Code”), you have the right:\n                        "
              ),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "1.to check whether the Company holds personal data about you and to access such data;"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2.to require the Company to correct any personal data relating to you which is inaccurate;"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3.to ascertain the Company’s policies and practices in relation to personal data and to be informed of the kind of personal data held by the Company;\n"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4.in relation to consumer credit data, to be informed, upon request, which items of personal data are routinely disclosed to credit reference agencies or debt collection agencies and be provided with further information to enable the making of an access and correction request to the relevant credit reference agency or debt collection agency; and"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5.in relation to consumer credit data, upon termination of your account by full repayment and on condition that there has not been, within 5 years immediately before account termination, any material default on your account, to instruct the Company to make a request to the credit reference agency to delete from its database any account data relating to your terminated account."
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        11.In accordance with the terms of the Ordinance, the Company has the right to charge a reasonable fee for the processing of any data access request.\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        12.You should send any requests for access to personal data or correction of personal data or for information regarding our policies and practices to:\n                      "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                        Money Plaza (Hong Kong) Limited\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        Room 21, One Midtown,\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        11 Hoi Shing Road, Tsuen Wan\n                        "
              ),
              _c("br"),
              _vm._v(
                "\n                        Hong Kong\n                        "
              ),
              _c("br"),
              _vm._v(" "),
              _c("a", { attrs: { href: "mailto:info@moneyplaza.com.hk" } }, [
                _vm._v("info@moneyplaza.com.hk"),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "13.Nothing in this Statement shall limit the rights of the data subjects under the Ordinance."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "14. The Company may have obtained a credit report on or access the database of the data subject from a credit reference agency in considering any application for loan-related\nproducts or facilities or conducting credit reviews from time to time. In the event that\nthe data subject wishes to access the credit report, the Company will advise the\ncontact details of the relevant credit reference agency.\n"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "15.In case of discrepancies between the English and Chinese versions, the English version shall prevail."
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }